<template>
  <div class="page_container content-box">
    <CostsList />
  </div>
</template>

<script>
import CostsList from './CostsList.vue';

export default {
  components: {
    CostsList,
  },
};
</script>

<style></style>
